export const modifyTransactionDate = (label: string, value: Date, dates: object, timePicker?: boolean) => {
  if (!timePicker) {
    label === 'endDate' ? value.setHours(23, 59, 59) : value.setHours(0, 0, 0);
  }
  let dateObj: any = dates;
  dateObj = {
    ...dateObj,
    [label]: (value.getTime() / 1000).toFixed(),
  };
  return dateObj;
};
